/* OnseHome — small vanilla JS, no dependencies. */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktopMQ = window.matchMedia('(min-width: 990px)');

  /* Uses the shop's own money format so JS prices match Liquid ({{ price | money }}). */
  function formatMoney(cents) {
    var format = window.OnseHomeMoneyFormat || '€{{amount_with_comma_separator}}';
    function group(value, decimals, thousands, decimal) {
      var parts = (value / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        default: return group(cents, 2, ',', '.');
      }
    });
  }

  function rootUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path;
  }

  /* ---------------------------------------------------------------------
   * Drawers (menu, cart)
   * ------------------------------------------------------------------- */
  var activeDrawer = null;

  function openDrawer(drawer, trigger) {
    if (!drawer || drawer === activeDrawer) return;
    if (activeDrawer) closeDrawer(activeDrawer, true);
    drawer.hidden = false;
    drawer._trigger = trigger || document.activeElement;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.body.classList.add('drawer-open');
    document.querySelectorAll('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    activeDrawer = drawer;
    var first = drawer.querySelector('[data-drawer-close]') || drawer.querySelector(FOCUSABLE);
    setTimeout(function () { if (first) first.focus(); }, reduceMotion ? 0 : 200);
  }

  function closeDrawer(drawer, silent) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.querySelectorAll('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var done = function () {
      drawer.hidden = true;
      if (!silent) document.body.classList.remove('drawer-open');
      if (activeDrawer === drawer) activeDrawer = null;
      if (!silent && drawer._trigger && drawer._trigger.focus) drawer._trigger.focus();
    };
    if (reduceMotion) done(); else setTimeout(done, 260);
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer(document.getElementById(openBtn.getAttribute('data-drawer-open')), openBtn);
      return;
    }
    var closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) {
      var d = closeBtn.closest('[data-drawer]');
      if (d) { if (closeBtn.tagName !== 'A') e.preventDefault(); closeDrawer(d); }
      return;
    }
    if (e.target.matches('[data-drawer]')) closeDrawer(e.target);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (activeDrawer) { closeDrawer(activeDrawer); return; }
      closeAllDropdowns();
    }
    if (e.key === 'Tab' && activeDrawer) {
      var nodes = Array.prototype.filter.call(activeDrawer.querySelectorAll(FOCUSABLE), function (n) { return n.offsetParent !== null; });
      if (!nodes.length) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------------------------------------------------------------
   * Header: Shop dropdown + shadow on scroll
   * ------------------------------------------------------------------- */
  function closeAllDropdowns() {
    document.querySelectorAll('[data-dropdown].is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var t = item.querySelector('[data-dropdown-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  document.querySelectorAll('[data-dropdown]').forEach(function (item) {
    var toggle = item.querySelector('[data-dropdown-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var open = item.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) {
        item.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-dropdown]')) closeAllDropdowns();
  });

  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------------------------------------------------------------
   * Quantity steppers (product form)
   * ------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn || btn.hasAttribute('data-cart-change')) return;
    var input = btn.closest('[data-qty]').querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    val = btn.hasAttribute('data-qty-plus') ? val + 1 : Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------------------
   * Cart (AJAX) + drawer re-render via Section Rendering API
   * ------------------------------------------------------------------- */
  var cartDrawer = document.getElementById('CartDrawer');

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
    var label = document.querySelector('[data-cart-count-label]');
    if (label) label.textContent = count + ' artikelen in winkelwagen';
  }

  function renderCartDrawer(html) {
    if (!cartDrawer || !html) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('CartDrawer');
    if (!fresh) return;
    cartDrawer.innerHTML = fresh.innerHTML;
    var countEl = cartDrawer.querySelector('[data-cart-item-count]');
    updateCartCount(countEl ? parseInt(countEl.getAttribute('data-cart-item-count'), 10) : 0);
  }

  function cartRequest(path, body) {
    return fetch(rootUrl(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({ sections: 'cart-drawer', sections_url: window.location.pathname }, body))
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) throw json;
        return json;
      });
    });
  }

  function addToCart(form, trigger) {
    var submit = trigger || form.querySelector('[data-add-to-cart]');
    var errorEl = form.querySelector('[data-form-error]');
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var id = parseInt(idInput && idInput.value, 10);
    if (!id) {
      if (errorEl) { errorEl.textContent = 'Kies eerst een uitvoering.'; errorEl.hidden = false; }
      return Promise.resolve();
    }
    var items = [{ id: id, quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1 }];

    if (submit) { submit.classList.add('is-loading'); submit.setAttribute('aria-busy', 'true'); }
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    return cartRequest('cart/add.js', { items: items })
      .then(function (json) {
        renderCartDrawer(json.sections && json.sections['cart-drawer']);
        openDrawer(cartDrawer, submit);
        document.dispatchEvent(new CustomEvent('cart:added', { detail: json }));
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Er ging iets mis. Probeer het opnieuw.';
        if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
      })
      .finally(function () {
        if (submit) { submit.classList.remove('is-loading'); submit.removeAttribute('aria-busy'); }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, e.submitter && e.submitter.hasAttribute('data-add-to-cart') ? e.submitter : null);
  });

  function changeLine(line, quantity) {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-busy');
    cartRequest('cart/change.js', { line: line, quantity: quantity })
      .then(function (json) { renderCartDrawer(json.sections && json.sections['cart-drawer']); })
      .catch(function () {})
      .finally(function () { cartDrawer.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    e.preventDefault();
    changeLine(parseInt(btn.getAttribute('data-line'), 10), parseInt(btn.getAttribute('data-qty-value'), 10));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(parseInt(input.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------------------------------------------------------------------
   * Product: gallery, variants, sticky + closing add-to-cart
   * ------------------------------------------------------------------- */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var form = section.querySelector('[data-product-form]');
    if (!form) return;
    var variantsScript = section.querySelector('[data-variants]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : null;
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var addLabel = form.querySelector('[data-add-label]');
    var stickyBar = section.querySelector('[data-sticky-atc]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var stickySubmit = section.querySelector('[data-sticky-submit]');
    var track = section.querySelector('[data-gallery-track]');
    var indexEl = section.querySelector('[data-gallery-index]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.gallery__slide')) : [];

    function submitMainForm(trigger) {
      if (addBtn && addBtn.disabled) return;
      addToCart(form, trigger);
    }

    /* Gallery */
    function showMedia(mediaId, smooth) {
      if (!mediaId || !slides.length) return;
      var target = null;
      slides.forEach(function (s) {
        var active = s.getAttribute('data-media-id') === String(mediaId);
        s.classList.toggle('is-active', active);
        if (active) target = s;
      });
      section.querySelectorAll('[data-thumb]').forEach(function (t) {
        var active = t.getAttribute('data-target') === String(mediaId);
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (target && !desktopMQ.matches) {
        track.scrollTo({ left: target.offsetLeft - slides[0].offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      }
      playActiveGalleryVideo();
    }

    function playActiveGalleryVideo() {
      slides.forEach(function (s) {
        var v = s.querySelector('video');
        if (!v) return;
        if (s.classList.contains('is-active') && !reduceMotion) { v.play().catch(function () {}); } else { v.pause(); }
      });
    }

    if (track && slides.length > 1) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var step = slides.length > 1 ? (slides[1].offsetLeft - slides[0].offsetLeft) : track.clientWidth;
          var i = Math.round(track.scrollLeft / Math.max(1, step));
          i = Math.max(0, Math.min(slides.length - 1, i));
          if (indexEl) indexEl.textContent = i + 1;
          slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
          playActiveGalleryVideo();
          ticking = false;
        });
      }, { passive: true });
      var initial = section.querySelector('.gallery__slide.is-active');
      if (initial && !desktopMQ.matches) track.scrollLeft = initial.offsetLeft - slides[0].offsetLeft;
      if (!initial && slides[0]) slides[0].classList.add('is-active');
    } else if (slides[0]) {
      slides[0].classList.add('is-active');
    }

    section.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (thumb) showMedia(thumb.getAttribute('data-target'), true);
    });

    /* Variants */
    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]:checked').forEach(function (i) { opts[parseInt(i.getAttribute('data-option-index'), 10)] = i.value; });
      return opts;
    }

    function markAvailability(opts) {
      if (!variants) return;
      form.querySelectorAll('[data-option-index]').forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        var available = variants.some(function (v) {
          if (!v.available || v.options[idx] !== input.value) return false;
          return v.options.every(function (o, i) { return i === idx || opts[i] === undefined || o === opts[i]; });
        });
        var label = form.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !available);
      });
      opts.forEach(function (value, idx) {
        var el = form.querySelector('[data-selected-value="' + idx + '"]');
        if (el) el.textContent = value;
      });
    }

    function setBuyState(variant) {
      var available = !!(variant && variant.available);
      var label = !variant ? 'Niet beschikbaar' : (available ? 'In winkelwagen' : 'Uitverkocht');
      if (addBtn) addBtn.disabled = !available;
      if (addLabel) addLabel.textContent = label;
      if (stickySubmit) { stickySubmit.disabled = !available; stickySubmit.textContent = label; }
      document.querySelectorAll('[data-cta-submit]').forEach(function (b) { b.disabled = !available; b.textContent = label; });
    }

    function updateVariant() {
      if (!variants) return;
      var opts = selectedOptions();
      var variant = variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }) || null;
      markAvailability(opts);
      if (variant) {
        idInput.value = variant.id;
        var money = formatMoney(variant.price);
        if (priceEl) {
          var html = '';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s> ';
          }
          html += '<span class="price__current">' + money + '</span>';
          priceEl.innerHTML = '<div class="price' + (variant.available ? '' : ' price--sold-out') + '">' + html + '</div>';
        }
        if (stickyPrice) stickyPrice.textContent = money;
        var unitEl = section.querySelector('[data-unit-price]');
        if (unitEl) {
          var n = 0;
          variant.options.forEach(function (o) { var m = String(o).toLowerCase().match(/^(\d+)\s*stuk/); if (m) n = parseInt(m[1], 10); });
          unitEl.hidden = n < 2;
          unitEl.textContent = n > 1 ? formatMoney(Math.round(variant.price / n)) + ' per stuk' : '';
        }
        document.querySelectorAll('[data-cta-price]').forEach(function (el) { el.textContent = money; });
        if (variant.featured_media) showMedia(variant.featured_media.id, true);
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState(window.history.state, '', url.toString());
        }
      } else {
        idInput.value = '';
      }
      setBuyState(variant);
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index]')) updateVariant();
    });
    if (variants) markAvailability(selectedOptions());

    /* Sticky bar (mobile) shows whenever the main button is not on screen, above or below */
    if (stickyBar && addBtn) {
      var stickyTicking = false;
      var updateSticky = function () {
        var rect = addBtn.getBoundingClientRect();
        stickyBar.hidden = rect.bottom > 0 && rect.top < window.innerHeight;
        stickyTicking = false;
      };
      window.addEventListener('scroll', function () {
        if (!stickyTicking) { stickyTicking = true; requestAnimationFrame(updateSticky); }
      }, { passive: true });
      updateSticky();
      if (stickySubmit) stickySubmit.addEventListener('click', function () { submitMainForm(stickySubmit); });
    }

    document.querySelectorAll('[data-cta-submit]').forEach(function (btn) {
      btn.addEventListener('click', function () { submitMainForm(btn); });
    });
  });

  /* ---------------------------------------------------------------------
   * Demo videos: play only while visible, muted; reduced motion shows controls
   * ------------------------------------------------------------------- */
  var demoVideos = document.querySelectorAll('.how__media video, video[data-autoplay-video]');
  demoVideos.forEach(function (v) {
    v.muted = true;
    v.setAttribute('playsinline', '');
    if (reduceMotion) { v.controls = true; }
  });
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var videoIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (v.closest('.gallery__slide') && !v.closest('.gallery__slide').classList.contains('is-active')) return;
        if (entry.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: 0.35 });
    demoVideos.forEach(function (v) { videoIO.observe(v); });
  }

  /* ---------------------------------------------------------------------
   * Review photo lightbox
   * ------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-review-photo]');
    if (!btn || typeof HTMLDialogElement === 'undefined') return;
    var img = btn.querySelector('img');
    if (!img) return;
    var dialog = document.createElement('dialog');
    dialog.className = 'lightbox';
    dialog.innerHTML = '<img alt=""><button type="button" class="lightbox__close" aria-label="Sluiten">&times;</button>';
    var big = dialog.querySelector('img');
    big.alt = img.alt;
    if (img.srcset) { big.srcset = img.srcset; big.sizes = '90vw'; }
    big.src = img.currentSrc || img.src;
    document.body.appendChild(dialog);
    dialog.addEventListener('close', function () { dialog.remove(); });
    dialog.addEventListener('click', function (ev) { if (ev.target === dialog || ev.target.closest('.lightbox__close')) dialog.close(); });
    dialog.showModal();
  });

  /* ---------------------------------------------------------------------
   * Related products (Product Recommendations API), loaded near the viewport
   * ------------------------------------------------------------------- */
  document.querySelectorAll('[data-related-products]').forEach(function (wrap) {
    var url = wrap.getAttribute('data-url');
    if (!url) return;
    var load = function () {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-related-products]');
        if (fresh && fresh.innerHTML.trim()) wrap.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '400px 0px' });
      io.observe(wrap);
    } else {
      load();
    }
  });

  /* Reviews: reveal the rest on request (desktop; mobile uses a swipe row) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-reviews-more]');
    if (!btn) return;
    var section = btn.closest('[data-reviews]');
    var open = section.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!btn.dataset.label) btn.dataset.label = btn.textContent;
    btn.textContent = open ? 'Toon minder' : btn.dataset.label;
  });

  /* Country select default (addresses) */
  document.querySelectorAll('select[data-default]').forEach(function (sel) {
    var def = sel.getAttribute('data-default');
    if (def) sel.value = def;
  });

  window.OnseHome = { openDrawer: openDrawer, closeDrawer: closeDrawer, addToCart: addToCart };
})();
